import { AmplifyTheme } from 'aws-amplify-react';

const MyLogoArea = Object.assign({}, AmplifyTheme.logoArea, { textAlign:'center' });

const MyFormSection = Object.assign({}, AmplifyTheme.sectionHeader, { marginLeft:'auto', marginRight:'auto', marginBottom:'0', padding:'0', width:'380px', background:'transparent', border:'none'});
const MySectionHeader = Object.assign({}, AmplifyTheme.sectionHeader, 
{ marginTop:'-0.5em',marginBottom:'41px', fontSize:'2.10em', fontWeight:'400',lineHeight:'1.2',background:'transparent', color:'#666666' });
const MySectionBody = Object.assign({}, AmplifyTheme.sectionHeader, { margin:'0', padding:'0',textAlign:'left',background:'transparent' });
const MySectionFooter = Object.assign({}, AmplifyTheme.sectionFooter, { marginLeft:'-75px', marginBottom:'-10px', padding:'0',width:'530px', border:'none'});
const MyInputRow = Object.assign({}, AmplifyTheme.input, { height:'44px',fontSize:'1em',color:'#262626'});
const MyErrorSection = Object.assign({}, AmplifyTheme.errorSection, { width:'530px', marginLeft:'auto',marginRight:'auto',padding:'1em', backgroundColor:'#ff5301',border:'none' });


const MyLink = Object.assign({}, AmplifyTheme.a, { color:'#1a66ff', textDecoration:'underline'});
const MyForgetpassLink = Object.assign({}, AmplifyTheme.loginForgetpass, { paddingBottom:'1em'});

const MyButtonRow = Object.assign({}, AmplifyTheme.button, { marginBottom:'39px',paddingTop:'0.4em', height:'64px', fontSize:'1.5em', backgroundColor:'', color:''});
const MyLargeButton = Object.assign({}, AmplifyTheme.loginLargeButton, 
{ marginTop:'32px', width:'100%', textAlign: 'center',cursor: 'pointer' });
const MyHalfButton = Object.assign({}, AmplifyTheme.loginHalfButton, 
{ marginTop:'32px', width:'187px', textAlign: 'center',cursor: 'pointer' });

const LapTheme = Object.assign({}, AmplifyTheme, {
  formSection:MyFormSection,
  sectionHeader: MySectionHeader,
  sectionBody:MySectionBody,
  sectionFooter:MySectionFooter,
  button:MyButtonRow,
  input:MyInputRow,
  a:MyLink,
  errorSection:MyErrorSection,
  container: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  logoArea: MyLogoArea,
  loginForgetpass:MyForgetpassLink,
  loginLargeButton:MyLargeButton,
  loginHalfButton:MyHalfButton,
});

export default LapTheme;

